
import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import { AuthHeader } from "../containers";
import AuthPageWrapper from "../components/layout/AuthPageWrapper/AuthPageWrapper";
import { isLoggedIn } from "../store/iam/selectors";
import AnalysisInProgressContextWrapper from "../analysis/ContextWrapper";
import { startParsiveWidget } from "../utils/parsive";


const ProtectedRoute = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const pagesWithoutSidebarAndHeader = ["/free-trial-setup", "/user/account/setup"]

    // Read from the store, not from the cookie. A cookie is read once while the page is drawn and
    // nothing redraws when it is deleted, so a session that ends leaves the page in place, still
    // asking the endpoints that just refused it.
    const isAuthenticated = useSelector((state) => isLoggedIn(state));

    // Start the Parsive widget only while the user is authenticated; the returned
    // function stops it when the user leaves the protected area (logout/unmount).
    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }
        return startParsiveWidget();
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return <Navigate to="/auth/login" replace />;
    }

    return (
        <AuthPageWrapper showSideBar={!pagesWithoutSidebarAndHeader.includes(pathname)}>
            <AuthHeader showPageHeader={!pagesWithoutSidebarAndHeader.includes(pathname)} />
            <AnalysisInProgressContextWrapper>
                <Outlet />
            </AnalysisInProgressContextWrapper>
        </AuthPageWrapper>
    );
};

export default ProtectedRoute;
